import { ROOT_ROLE } from "../../constants/user";

export const DEFAULT_CUSTOMER_ID = "glowco";

export const customerSelectionForIdentity = ({
  role,
  customerId,
  selectedCustomerId,
}: Readonly<{
  role: string | null;
  customerId: string | null;
  selectedCustomerId: string | null;
}>): string | null => {
  if (!role) return selectedCustomerId;
  if (role.includes(ROOT_ROLE)) return selectedCustomerId;
  return customerId;
};
